/**
 * Style marshal classes
 */
export const DEPENDENCIES_OVERLAY_CLASS_NAME = 'dependencies-overlay';
export const DEPENDENCY_LINE_CLASS_NAME = 'dependency-line';
